if (!customElements.get('product-media-gallery')) {
  customElements.define(
    'product-media-gallery',
    class ProductMediaGallery extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.mediaList = this.querySelector('.product__media-list');
        this.thumbs = this.querySelectorAll('.product__media-thumbs .thumbnail');
        this.carouselQuery = window.matchMedia('(max-width: 1024px)');

        this.onCarouselPointerDown = this.onCarouselPointerDown.bind(this);
        this.onCarouselPointerMove = this.onCarouselPointerMove.bind(this);
        this.onCarouselPointerUp = this.onCarouselPointerUp.bind(this);
        this.onCarouselDragStart = this.onCarouselDragStart.bind(this);

        if (this.mediaList && !this.mediaList.querySelector('.product__media-item--active')) {
          const firstMedia = this.mediaList.querySelector('.product__media-item');
          if (firstMedia) {
            firstMedia.classList.add('product__media-item--active');
          }
        }

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.setActiveMedia(thumb.dataset.mediaId));
          thumb.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this.setActiveMedia(thumb.dataset.mediaId);
            }
          });
        });

        this.syncThumbsFromMedia();
        this.initCarouselDrag();
      }

      disconnectedCallback() {
        if (!this.mediaList) return;

        this.mediaList.removeEventListener('pointerdown', this.onCarouselPointerDown);
        this.mediaList.removeEventListener('dragstart', this.onCarouselDragStart);
        this.mediaList.removeEventListener('pointermove', this.onCarouselPointerMove);
        this.mediaList.removeEventListener('pointerup', this.onCarouselPointerUp);
        this.mediaList.removeEventListener('pointercancel', this.onCarouselPointerUp);
      }

      initCarouselDrag() {
        if (!this.mediaList) return;

        this.mediaList.addEventListener('pointerdown', this.onCarouselPointerDown);
        this.mediaList.addEventListener('dragstart', this.onCarouselDragStart);
      }

      isCarouselLayout() {
        return this.carouselQuery.matches;
      }

      onCarouselDragStart(event) {
        if (this.isCarouselLayout()) event.preventDefault();
      }

      onCarouselPointerDown(event) {
        if (!this.isCarouselLayout() || event.pointerType === 'touch') return;
        if (event.button !== 0) return;

        this.isCarouselPointerDown = true;
        this.hasCarouselDragged = false;
        this.carouselStartX = event.clientX;
        this.carouselStartScroll = this.mediaList.scrollLeft;

        this.mediaList.setPointerCapture(event.pointerId);
        this.mediaList.addEventListener('pointermove', this.onCarouselPointerMove);
        this.mediaList.addEventListener('pointerup', this.onCarouselPointerUp);
        this.mediaList.addEventListener('pointercancel', this.onCarouselPointerUp);
      }

      onCarouselPointerMove(event) {
        if (!this.isCarouselPointerDown) return;

        const dx = event.clientX - this.carouselStartX;
        if (!this.hasCarouselDragged && Math.abs(dx) < 6) return;

        this.hasCarouselDragged = true;
        this.mediaList.classList.add('is-dragging');
        this.mediaList.scrollLeft = this.carouselStartScroll - dx;
      }

      onCarouselPointerUp() {
        this.isCarouselPointerDown = false;
        this.mediaList.classList.remove('is-dragging');
        this.mediaList.removeEventListener('pointermove', this.onCarouselPointerMove);
        this.mediaList.removeEventListener('pointerup', this.onCarouselPointerUp);
        this.mediaList.removeEventListener('pointercancel', this.onCarouselPointerUp);

        if (this.hasCarouselDragged) {
          const preventClick = (clickEvent) => {
            clickEvent.preventDefault();
            clickEvent.stopPropagation();
            this.mediaList.removeEventListener('click', preventClick, true);
          };

          this.mediaList.addEventListener('click', preventClick, true);
        }
      }

      setActiveMedia(mediaId) {
        if (!this.mediaList || !mediaId) return;

        this.mediaList.querySelectorAll('.product__media-item').forEach((item) => {
          item.classList.remove('product__media-item--active');
        });

        const activeMedia = this.mediaList.querySelector(`[data-media-id="${mediaId}"]`);
        if (activeMedia) {
          activeMedia.classList.add('product__media-item--active');
        }

        this.syncThumbs(mediaId);
      }

      syncActiveMedia(mediaId) {
        this.setActiveMedia(mediaId);
      }

      syncThumbs(mediaId) {
        this.thumbs.forEach((thumb) => {
          const isActive = thumb.dataset.mediaId === mediaId;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');

          if (isActive && !this.isCarouselLayout()) {
            thumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        });
      }

      syncThumbsFromMedia() {
        const activeMedia = this.mediaList?.querySelector('.product__media-item--active');
        if (activeMedia) {
          this.syncThumbs(activeMedia.dataset.mediaId);
        }
      }
    },
  );
}
